/* @flow */
/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {
    addToTable, openNewTable, closeTables, showTable, tableSave, goTableNextPage, goTablePrevPage, addTableList,
    removeTableList, fetchLayouts, selectLayout
} from '../../common/tables/actions';
import NewTablePopup from './NewTablePopup';
import {openMenu} from '../../common/menu/actions';
import CloseButton from '../components/buttons/CloseButton';
import ArrLeftButton from '../components/buttons/ArrLeftButton';
import ArrRightButton from '../components/buttons/ArrRightButton';
import Currency from '../components/numbers/Currency';
import Popup from '../menu/popup/Popup';
import {showPopupInMenu} from '../../common/menu/actions';
import {hasTablesProduct, hasTableProduct} from '../../common/lib/util';

class TablesPopup extends React.Component {

    state: State = {
        sortedByAZ: false
    };

    static propTypes = {
        msg: React.PropTypes.object,
        barId: React.PropTypes.number,
        layouts: React.PropTypes.object,
        selectLayout: React.PropTypes.func,
        fetchLayouts: React.PropTypes.func,
        showPopupInMenu: React.PropTypes.func,
        addTableList: React.PropTypes.func,
        removeTableList: React.PropTypes.func,
        goTableNextPage: React.PropTypes.func,
        goTablePrevPage: React.PropTypes.func,
        openMenu: React.PropTypes.func,
        openNewTable: React.PropTypes.func,
        addToTable: React.PropTypes.func,
        showTable: React.PropTypes.func,
        tableSave: React.PropTypes.func,
        openTable: React.PropTypes.func,
        closeTables: React.PropTypes.func,
        newTableVisible: React.PropTypes.bool,
        defaultTablesVisible: React.PropTypes.bool,
        selectedProducts: React.PropTypes.object,
        newTableUuid: React.PropTypes.string,
        maxTablePage: React.PropTypes.number,
        tablePage: React.PropTypes.number,
        countTablePage: React.PropTypes.number,
        showTableId: React.PropTypes.string
    };

    constructor(props) {
        super(props);

        this.manageTable = this.manageTable.bind(this);
        this.sortByAZ = this.sortByAZ.bind(this);
        this.openLayoutPopup = this.openLayoutPopup.bind(this);
        this.renderPopup = this.renderPopup.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {tables} = this.props;
        const {tables: nextTables} = nextProps;

        if (!!tables && !!nextTables) {
            if (tables.size > 0 && nextTables.size === 0) {
                this.openLayoutPopup();
            }
        }
    }

    componentWillMount() {
        const {tables} = this.props;
        if (!tables) {
            this.openLayoutPopup();
        } else if (tables.size === 0) {
            this.openLayoutPopup();
        }
    }

    openLayoutPopup() {
        const {fetchLayouts, barId} = this.props;
        fetchLayouts(barId);
    }

    renderPopup(layouts, selectLayout) {
        const {msg} = this.props;

        return (
            <div className="popup-inner">
                <h1 className="popup-title">{msg.tables.layout.select}</h1>
                <div className="popup-list">
                  <div className="popup-list-key">
                    <div className="boxBtn color-white"
                         onClick={() => selectLayout()}>
                        <div className="boxBtn-inner">
                            <span>
                                {msg.tables.layout.noLayout}
                            </span>
                        </div>
                    </div>
                  </div>
                    {!!layouts && layouts.map(layout =>
                      <div className="popup-list-key" key={`layout-${layout.get('id')}`}>
                        <div className="boxBtn color-white"
                             onClick={() => selectLayout(layout.get('id'))}>
                            <div className="boxBtn-inner">
                                <span>
                                    {layout.get('name')}
                                </span>
                            </div>
                        </div>
                      </div>
                    )}
                </div>
            </div>
        );
    }

    sortByAZ() {
        const {sortedByAZ} = this.state;
        this.setState({sortedByAZ: !sortedByAZ})
    }

    manageTable(id) {
        const {showTable, tableSave, selectedProducts, showTableId, addToTable, msg} = this.props;
        if (selectedProducts.size > 0) {
            tableSave(id, msg);
        } else if (!!showTableId) {
            addToTable(id);
        } else {
            showTable(id);
        }
    }

    render() {
        const {
            openMenu, openNewTable, defaultTablesVisible, closeTables, newTableVisible, tables, newTableUuid,
            showTableId, goTableNextPage, goTablePrevPage, tablePage, maxTablePage, removeTableList,
            countTablePage, layouts, selectLayout, msg
        } = this.props;
        const {sortedByAZ} = this.state;

        const tablesToDisplay = sortedByAZ
            ? tables.filter(t => t.get('page') === tablePage).filter(t => !!t.get('name')).sort((a, b) => a.get('name').localeCompare(b.get('name')))
            : tables.filter(t => t.get('page') === tablePage).sortBy(t => t.get('position'));

        return (
            <div id="tables-popup">
                <Popup body={this.renderPopup(layouts, selectLayout)}/>
                <div className="pageTables" id="bills-list">
                    {tablesToDisplay.map(table => {
                        const stable = table.get('stable');
                        const open = table.get('open');
                        let tableColor = '';
                        let empty = !hasTableProduct(table);

                        if (stable) {
                            if (empty) {
                                tableColor = 'gray'
                            } else {
                                tableColor = 'green'
                            }
                        } else if (open) {
                            if (empty) {
                                tableColor = 'greenLight'
                            } else {
                                tableColor = 'green'
                            }
                        }

                        return (
                          <div className="pageTables-key">
                            <div
                                className={`boxBtn color-${tableColor} ${!!showTableId && table.get('uuid') === showTableId ? 'disabled' : ''}`}
                                key={`table-${table.get('uuid')}`}
                                onClick={() => open ? this.manageTable(table.get('uuid')) : openNewTable(table.get('uuid'))}
                            >
                                <div className="boxBtn-inner">
                                    {open &&
                                    <span>{table.get('name')} {(!stable || (stable && !empty)) && <Currency integer isBlock value={Math.round(table.get('totalPriceVat'))} currency={'CZK'}/>}</span>
                                    }
                                    {!open &&
                                    <span>{msg.tables.newTable}</span>
                                    }
                                </div>
                            </div>
                          </div>
                        );
                    })}

                    <div className="pageTables-controls">
                      <div className="pageTables-controls-key">
                        <div className={`boxBtn text-xl color-${sortedByAZ ? 'greenLight' : 'gray'}`} onClick={this.sortByAZ}>
                            <div className="boxBtn-inner">
                                <span>A-Z</span>
                            </div>
                        </div>
                      </div>
                      <div className="pageTables-controls-key view-half">
                        <div className={`boxBtn view-half text-xl color-white ${countTablePage === 0 || hasTablesProduct(tablesToDisplay) ? 'disabled' : ''}`} onClick={() => removeTableList()}>
                            <div className="boxBtn-inner">
                                -
                            </div>
                        </div>
                      </div>
                      <div className="pageTables-controls-key view-half">
                        <div className={`boxBtn view-half text-xl color-white ${countTablePage >= maxTablePage ? 'disabled' : ''}`} onClick={this.openLayoutPopup}>
                            <div className="boxBtn-inner">
                                +
                            </div>
                        </div>
                      </div>
                      <div className="pageTables-controls-key">
                      </div>
                      <div className="pageTables-controls-key">
                      </div>
                        {!defaultTablesVisible &&
                        <div className="pageTables-controls-key">
                          <div className="boxBtn color-white" onClick={() => closeTables()}>
                              <CloseButton/>
                          </div>
                        </div>
                        }
                        {!defaultTablesVisible &&
                        <div className="pageTables-controls-key">
                        </div>
                        }
                        {defaultTablesVisible &&
                        <div className="pageTables-controls-key">
                          <div className="boxBtn color-greenLight" onClick={() => openMenu()}>
                              <div className="boxBtn-inner">
                                <svg className={`shape shape-bars`}>
                                  <use xlinkHref={`#shape-bars`}></use>
                                </svg>
                              </div>
                          </div>
                        </div>
                        }
                        {defaultTablesVisible &&
                        <div className="pageTables-controls-key">
                          <div className="boxBtn color-green" onClick={() => closeTables()}>
                              <div className="boxBtn-inner">
                                  <span>{msg.tables.toCashbox}</span>
                              </div>
                          </div>
                        </div>
                        }
                        {countTablePage > 1 &&
                        <div className="pageTables-controls-key">
                          <div className="boxBtn color-transparent text-lr">
                              <div className="boxBtn-inner">
                                  <span>{tablePage}/{countTablePage}</span>
                              </div>
                          </div>
                        </div>
                        }
                        {countTablePage < 2 &&
                        <div className="pageTables-controls-key">
                        </div>
                        }
                      <div className="pageTables-controls-key">
                        <div className={`boxBtn color-white ${countTablePage < 2 ? 'disabled' : ''}`} onClick={() => goTablePrevPage()}>
                            <ArrLeftButton/>
                        </div>
                      </div>
                      <div className="pageTables-controls-key">
                        <div className={`boxBtn color-white ${countTablePage < 2 ? 'disabled' : ''}`} onClick={() => goTableNextPage()}>
                            <ArrRightButton/>
                        </div>
                      </div>
                    </div>
                </div>
                {newTableVisible && newTableUuid &&
                <NewTablePopup />
                }
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    layouts: state.categories.get('layouts'),
    maxTablePage: state.categories.get('maxTablePage'),
    countTablePage: state.categories.get('countTablePage'),
    tablePage: state.categories.get('tablePage'),
    newTableVisible: state.tables.get('newTableVisible'),
    tables: state.categories.get('tables'),
    defaultTablesVisible: state.tables.get('defaultTablesVisible'),
    newTableUuid: state.tables.get('newTableUuid'),
    selectedProducts: state.categories.get('selectedProducts'),
    showTableId: state.categories.get('showTableId')
}), {
    openNewTable, closeTables, showTable, tableSave, addToTable, openMenu, goTableNextPage, goTablePrevPage,
    addTableList, removeTableList, showPopupInMenu, fetchLayouts, selectLayout
})(TablesPopup);



// WEBPACK FOOTER //
// ./src/browser/tables/TablesPopup.js